import { useTranslation } from 'react-i18next';
import { useUserContext } from '@/auth/UserContext';
import type { AddPhoneContext, FamilyMember } from '@/types/user';
import { getNameWithRole } from '@/utils/person';

export const usePhoneForm = (
  member?: FamilyMember,
  addContext?: AddPhoneContext,
) => {
  const { t } = useTranslation();
  const { user, currentProfile } = useUserContext();

  const person = addContext ?? member ?? user;
  const isFamilyMember = !!(member || addContext);

  const displayName = getNameWithRole({
    person: user,
    personType: person?.personType,
    lowercaseRole: isFamilyMember,
  });

  const buildMessage = (isDelete: boolean) => {
    const classSuffix =
      isFamilyMember && currentProfile?.user.className
        ? `, ${currentProfile.user.className}`
        : '';
    const nameWithRole = getNameWithRole({
      person: user,
      personType: person?.personType,
      lowercaseRole: true,
    });
    const userDetails = `${nameWithRole}${classSuffix}`;

    const templateKey = addContext
      ? 'changePhone.creationTemplate'
      : isDelete
        ? 'changePhone.deleteNumberTemplate'
        : 'changePhone.newNumberTemplate';

    return t(templateKey, { userDetails });
  };

  return {
    isFamilyMember,
    personType: person?.personType,
    targetUserPublicId:
      addContext?.studentUserPublicId ??
      member?.userPublicId ??
      user?.userPublicId,
    displayName,
    currentPhone: addContext ? undefined : (member ?? user)?.phoneNumber,
    buildMessage,
  };
};
